import App from '@/models/App'

export default class ShipLaborAttendanceDaily extends App {
    static get entity() {
        return 'ShipLaborAttendanceDaily'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipSailorId: this.attr(''),
            fullName: this.attr(''),
            workingHours: this.attr(''),
            isArticle72: this.attr(false),
            isOvertime: this.attr(false),
            boardingAt: this.attr(''),
            holiday: this.attr(''),
            skill: this.attr(''),
            attendance: this.attr([]),
            latestSettleAttendance: this.attr(null),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, searchAt, isDisembark = true, withLatestAttendance = true) {
                // isDisembark true: 当日下船した船員打刻は返さない, false: 当日下船した船員も返す
                return this.get(`${shipId}/dailies/labor/attendances`, {
                    params: { searchAt: searchAt, isDisembark, withLatestAttendance },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
